import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function StackedBarChartIcon(props: IconProps) {
    return <Icon {...props} iconKey={"stacked_bar_chart"}/>
}
